import Head from 'next/head'
import Layout from '../components/Layout'

import styles from './blog.module.scss'



import Link from 'next/link'
import { Center, Pagination, Space, Text } from '@mantine/core';
import { MenuId } from '../components/Header'
import { useEffect, useState } from 'react'
import { ImageData, WPPost } from '../lib/definitions'
import { GetServerSideProps } from 'next'
import { getWpBlogCount, getWpBlogPosts } from '../lib/data'
import EmailSignupBanner from '../components/EmailSignupBanner'
import { formattedDateFromString } from '../components/Localization'
import { AspectBox } from '../components/AspectBox';
const pageSize = 10;

export default function Blog({data} : {data: {posts : WPPost[], postCount: number}}) {
    

    const [currentPage, setCurrentPage] = useState(1);
    const [postCount, setPostCount] = useState(data.postCount);
    const [currentPosts, setCurrentPosts] = useState(data.posts);

    useEffect(()=>
    {
        async function getMorePosts()
        {
            let posts = await fetch(`/n/api/blogposts?count=${pageSize}&offset=${pageSize*(currentPage-1)}`, {
                method: 'GET',  cache: "no-store" as RequestCache, credentials: "include" as RequestCredentials
            });
            let p = await posts.json();

            setCurrentPosts(p);
        }

        getMorePosts();

    }, [currentPage]);

    let dimensions = new Map<number, ImageData>();


    return (
        <Layout menuId={MenuId.blog}>
            <Head>
                <title>The Raw Umber Blog</title>
                <meta name="description" content="Hints and tips about drawing and painting, plus news from Raw Umber Studios"/>
            </Head>
            <div className = {styles.mainContent}>
            <h1>The Raw Umber Blog</h1>
            <Text ta='center'>Hints and tips about drawing and painting, plus news from Raw Umber Studios.</Text>
            <Space h='md'/>
            <Center><Pagination value={currentPage} onChange={setCurrentPage} total={Math.ceil(data.postCount/pageSize)}/></Center>
            <Space h='md'/>

            <div className={styles.list}>
            {currentPosts.map(x=> <BlogPostSummary key={x.id} blogPost={x}/>)}
            </div>

            <Space h='md'/>

            <Center><Pagination value={currentPage} onChange={setCurrentPage} total={Math.ceil(data.postCount/pageSize)}/></Center>
            <Space h='lg'/>

            </div>
            <EmailSignupBanner/>
        </Layout>
    )
}

function BlogPostSummary(props: {blogPost:WPPost})
{
    const w = props.blogPost;
    const link = "/" + w.slug;

    return (
        <div className={styles.item}>
    <h2 className={styles.h2}><Link href={link}>{w.title}</Link></h2>
    <h3 className={styles.h3}>{formattedDateFromString(w.date)}</h3>
    <div className={styles.imageContainer}>        
        {(props.blogPost.imageData && props.blogPost.imageData.height) && 
        <AspectBox width={ props.blogPost.imageData.width} height={ props.blogPost.imageData.height}>

                    <Link href={link}>
                    {/*eslint-disable-next-line @next/next/no-img-element*/}
                        <img alt='Image' src={`/n/api/wpimage?slug=${encodeURIComponent(props.blogPost.imageData.filename)}&w=840&t=${props.blogPost.imageData.updatedAt}`}/>
                    </Link>
                    </AspectBox>
}
            </div>
            
    <div>{props.blogPost.excerpt} <Link href={link}>Read more ...</Link></div>
    
    </div>
    );


}

export const getServerSideProps : GetServerSideProps = async (context)=>
{


    const result: WPPost[] = await getWpBlogPosts(0, pageSize);
    const count = await getWpBlogCount();


    console.log(count);
    return {
        props: {
          data: 
          { 
              posts: result,
              postCount: count
          }
        }
    }
  
  }


